<div class="op-wp-loading-skeleton">
  <op-content-loader
    [viewBox]="viewBox"
  >
    <svg:rect x="0" y="0" rx="3" ry="3" width="20%" height="35%"/>
    <svg:rect x="0" y="40%" rx="3" ry="3" width="100%" height="35%"/>
  </op-content-loader>
</div>